import { Button, Typography, Stack } from "@mui/material";

const CustomTextArea = (props) => (
  <textarea
    style={{
      border: "1px solid #ddd",
      width: "100%",
      minHeight: 240,
      padding: 8,
      borderRadius: 8,
      outline: "1px solid #aaa"
    }}
    {...props}
  />
);

export default function HeatMap() {
  return (
    <div
      style={{
        maxWidth: "90%",
        margin: "auto"
      }}
    >
      <Typography variant="h3">Heat Map Integration</Typography>
      <Typography variant="body1">Heat Map Code</Typography>
      <CustomTextArea placeholder="Code to be placed in <head> tag" />
      <Stack direction="row" justifyContent="end">
        <Button sx={{ marginBlock: 2 }} variant="contained">
          Save
        </Button>
      </Stack>
    </div>
  );
}
